// import React, { useState, useEffect } from "react";
// import {
//   Form,
//   Input,
//   Button,
//   Select,
//   Upload,
//   Card,
//   Space,
//   Divider,
//   Layout,
//   Typography
// } from "antd";
// import {
//   UploadOutlined,
//   PlusOutlined
// } from "@ant-design/icons";

// import { MenuOutlined } from "@ant-design/icons";
// import axios from "axios";
// import Sidebar from "../Components/Sidebar";
// import { BASE_URL } from "../Config";
// import SuccessPopup from "../Components/popup/SuccessPopup";
// import ErrorPopup from "../Components/popup/ErrorPopup";
// import countries from "world-countries";

// const { TextArea } = Input;
// const { Header, Content } = Layout;
// const { Text } = Typography;

// const AsanaUpload = () => {
//   const [form] = Form.useForm();

//   const [mainImage, setMainImage] = useState(null);
//   const [mainImageList, setMainImageList] = useState([]);

//   const [variationImages, setVariationImages] = useState([]);
//   const [variationImageList, setVariationImageList] = useState([]);

//   const [variationPoses, setVariationPoses] = useState([
//     { name: "", sanskrit: "", english: "", poseType: "", mediaLink: "" },
//   ]);

//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);

//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const user = JSON.parse(localStorage.getItem("user"));
//   const role = user?.role || "user";

//   useEffect(() => {
//     const checkScreen = () => setIsMobile(window.innerWidth <= 768);
//     checkScreen();
//     window.addEventListener("resize", checkScreen);
//     return () => window.removeEventListener("resize", checkScreen);
//   }, []);

//   const countryOptions = countries
//     .map((c) => ({
//       label: c.name.common,
//       value: c.name.common,
//     }))
//     .sort((a, b) => a.label.localeCompare(b.label));

//   const handleSubmit = async (values) => {
//     setSubmitLoading(true);

//     const formData = new FormData();

//     const poseTypeArray = values.poseType
//       .split(",")
//       .map((v) => v.trim())
//       .filter(Boolean);

//     // Basic fields
//     formData.append("name", values.name);
//     formData.append("sanskrit", values.sanskrit);
//     formData.append("tamil", values.tamil);
//     formData.append("english", values.english);
//     formData.append("breath", values.breath);
//     formData.append("chakra", values.chakra);
//     formData.append("level", values.level);

//     poseTypeArray.forEach((item) => formData.append("poseType[]", item));

//     // JSON values
//     formData.append("howToDo", JSON.stringify(values.howToDo));
//     formData.append("benefits", JSON.stringify(values.benefits));
//     formData.append("precautions", JSON.stringify(values.precautions));
//     formData.append("variationPoses", JSON.stringify(variationPoses));

//     if (mainImage) formData.append("mainImage", mainImage);
//     variationImages.forEach((img) => formData.append("images", img));

//     const user = JSON.parse(localStorage.getItem("user"));
//     const role = user?.role || "user";

//     const token = sessionStorage.getItem("token");

//     const apiUrl =
//       role === "admin"
//         ? `${BASE_URL}/asanadetails`
//         : `${BASE_URL}/userasanas/submit`;

//     try {
//       await axios.post(apiUrl, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setSuccessPopup(true);

//       form.resetFields();
//       setMainImage(null);
//       setMainImageList([]);
//       setVariationImages([]);
//       setVariationImageList([]);
//       setVariationPoses([
//         {
//           name: "",
//           sanskrit: "",
//           country: "",
//           english: "",
//           poseType: "",
//           mediaLink: "",
//         },
//       ]);
//     } catch (err) {
//       setErrorPopup(true);
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   const addVariationPose = () => {
//     setVariationPoses([
//       ...variationPoses,
//       { name: "", sanskrit: "", english: "", poseType: "", mediaLink: "" },
//     ]);
//   };

//   const updateVariationPose = (index, field, val) => {
//     const updated = [...variationPoses];
//     updated[index][field] = val;
//     setVariationPoses(updated);
//   };

//   return (
//     <Layout style={{ minHeight: "100vh" }}>
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}

//         collapsedWidth="0"
//         role={role === "user" ? "user" : "admin"}
//       />
//       <Layout
//         className="main-layout"
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 40 : 210,
//           transition: "0.3s",
//           padding: isMobile ? 10 : 20,
//         }}
//       >
//         <Header
//           className="MainHeader"
//         >
//           {isMobile && (
//             <Button
//               type="text"
//               icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }}
//             />
//           )}
//           <div style={{ flex: 1 }}>
//             <Text style={{ fontSize: 20, fontWeight: "bold" }}>{role === "admin" ? "Add Asana" : "Upload User Asana"}</Text>
//           </div>
//         </Header>

//         <Content style={{ padding: 20 }}>
//           <Card style={{ maxWidth: 900, margin: "0 auto" }}>
//             <Form
//               form={form}
//               layout="vertical"
//               onFinish={handleSubmit}
//               autoComplete="off"
//             >
//               <Card title="Basic Information" style={{ marginBottom: 20 }}>
//                 <Form.Item
//                   label="Asana Name"
//                   name="name"
//                   rules={[{ required: true, message: "Please enter name" }]}
//                 >
//                   <Input placeholder="Example: Trikonasana" />
//                 </Form.Item>

//                 <Form.Item
//                   label="Sanskrit Name"
//                   name="sanskrit"
//                   rules={[{ required: true, message: "Enter Sanskrit" }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item
//                   label="Tamil Name"
//                   name="tamil"
//                   rules={[{ required: true, message: "Enter Tamil" }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item
//                   label="English Name"
//                   name="english"
//                   rules={[{ required: true, message: "Enter English" }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item
//                   label="Pose Type"
//                   name="poseType"
//                   rules={[{ required: true, message: "Enter pose types" }]}
//                 >
//                   <Input placeholder="Example: twist, seated, forward bend" />
//                 </Form.Item>

//                 <Form.Item label="Level" name="level">
//                   <Select>
//                     <Select.Option value="all levels">All Levels</Select.Option>
//                     <Select.Option value="beginner">Beginner</Select.Option>
//                     <Select.Option value="intermediate">
//                       Intermediate
//                     </Select.Option>
//                     <Select.Option value="advanced">Advanced</Select.Option>
//                   </Select>
//                 </Form.Item>

//                 <Form.Item
//                   label="Breath"
//                   name="breath"
//                   rules={[{ required: true, message: "Enter breath info" }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item
//                   label="Chakra"
//                   name="chakra"
//                   rules={[{ required: true, message: "Enter chakra" }]}
//                 >
//                   <Input />
//                 </Form.Item>
//               </Card>

//               <Card title="Instructions" style={{ marginBottom: 20 }}>
//                 <Form.Item
//                   label="How To Do"
//                   name="howToDo"
//                   rules={[{ required: true, message: "Enter steps" }]}
//                 >
//                   <TextArea rows={4} />
//                 </Form.Item>

//                 <Form.Item
//                   label="Benefits"
//                   name="benefits"
//                   rules={[{ required: true, message: "Enter benefits" }]}
//                 >
//                   <TextArea rows={3} />
//                 </Form.Item>

//                 <Form.Item
//                   label="Precautions"
//                   name="precautions"
//                   rules={[{ required: true, message: "Enter precautions" }]}
//                 >
//                   <TextArea rows={3} />
//                 </Form.Item>
//               </Card>

//               <Card title="Main Image" style={{ marginBottom: 20 }}>
//                 <Upload
//                   fileList={mainImageList}
//                   beforeUpload={(file) => {
//                     setMainImage(file);
//                     setMainImageList([file]);
//                     return false;
//                   }}
//                   onRemove={() => {
//                     setMainImage(null);
//                     setMainImageList([]);
//                   }}
//                   maxCount={1}
//                 >
//                   <Button icon={<UploadOutlined />}>Upload Image</Button>
//                 </Upload>
//               </Card>

//               <Card
//                 title="Variation Poses"
//                 extra={
//                   <Button icon={<PlusOutlined />} onClick={addVariationPose}>
//                     Add Variation
//                   </Button>
//                 }
//               >
//                 {variationPoses.map((pose, idx) => (
//                   <Card
//                     key={idx}
//                     type="inner"
//                     title={`Variation ${idx + 1}`}
//                     style={{ marginBottom: 15, position: "relative" }}
//                   >
//                     {/* DELETE BUTTON */}
//                     <Button
//                       danger
//                       size="small"
//                       style={{
//                         position: "absolute",
//                         top: 10,
//                         right: 10,
//                         fontSize: 12,
//                       }}
//                       onClick={() => {
//                         const updatedPoses = variationPoses.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVariationPoses(updatedPoses);

//                         const updatedImages = variationImages.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVariationImages(updatedImages);

//                         const updatedImageList = variationImageList.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVariationImageList(updatedImageList);
//                       }}
//                     >
//                       Delete
//                     </Button>

//                     <Space direction="vertical" style={{ width: "100%" }}>
//                       <Input
//                         placeholder="name"
//                         value={pose.name}
//                         onChange={(e) =>
//                           updateVariationPose(idx, "name", e.target.value)
//                         }
//                       />

//                       <Input
//                         placeholder="Sanskrit"
//                         value={pose.sanskrit}
//                         onChange={(e) =>
//                           updateVariationPose(idx, "sanskrit", e.target.value)
//                         }
//                       />

//                       <Select
//                         showSearch
//                         placeholder="Select country"
//                         value={pose.country || undefined}
//                         options={countryOptions}
//                         optionFilterProp="label"
//                         onChange={(value) =>
//                           updateVariationPose(idx, "country", value)
//                         }
//                       />

//                       <Input
//                         placeholder="English"
//                         value={pose.english}
//                         onChange={(e) =>
//                           updateVariationPose(idx, "english", e.target.value)
//                         }
//                       />
//                       <Input
//                         placeholder="poseType"
//                         value={pose.poseType}
//                         onChange={(e) =>
//                           updateVariationPose(idx, "poseType", e.target.value)
//                         }
//                       />
//                       <Input
//                         placeholder="mediaLink"
//                         value={pose.mediaLink}
//                         onChange={(e) =>
//                           updateVariationPose(idx, "mediaLink", e.target.value)
//                         }
//                       />

//                       <Upload
//                         fileList={variationImageList.filter(
//                           (_, i) => i === idx,
//                         )}
//                         beforeUpload={(file) => {
//                           const updatedImages = [...variationImages];
//                           updatedImages[idx] = file;
//                           setVariationImages(updatedImages);

//                           const updatedList = [...variationImageList];
//                           updatedList[idx] = file;
//                           setVariationImageList(updatedList);

//                           return false;
//                         }}
//                         onRemove={() => {
//                           const updatedImages = variationImages.filter(
//                             (_, i) => i !== idx,
//                           );
//                           setVariationImages(updatedImages);

//                           const updatedList = variationImageList.filter(
//                             (_, i) => i !== idx,
//                           );
//                           setVariationImageList(updatedList);
//                         }}
//                         maxCount={1}
//                       >
//                         <Button icon={<UploadOutlined />}>Upload Image</Button>
//                       </Upload>
//                     </Space>
//                   </Card>
//                 ))}
//               </Card>

//               <Divider />

//               <Form.Item>
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   loading={submitLoading}
//                   disabled={submitLoading}
//                 >
//                   {submitLoading ? "Uploading..." : "Upload Asana"}
//                 </Button>
//               </Form.Item>

//               <SuccessPopup
//                 open={successPopup}
//                 onClose={() => setSuccessPopup(false)}
//                 message="Asana uploaded successfully!"
//                 navigate="/all-users"
//               />

//               <ErrorPopup
//                 open={errorPopup}
//                 onClose={() => setErrorPopup(false)}
//                 message="Upload failed. Try again."
//               />
//             </Form>
//           </Card>
//         </Content>
//       </Layout>
//     </Layout>
//   );
// };

// export default AsanaUpload;

import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Select,
  Upload,
  Card,
  Space,
  Divider,
  Layout,
  Typography,
  Input,
} from "antd";
import { UploadOutlined, PlusOutlined, MenuOutlined } from "@ant-design/icons";
import axios from "axios";
import Sidebar from "../Components/Sidebar";
import { BASE_URL } from "../Config";
import SuccessPopup from "../Components/popup/SuccessPopup";
import ErrorPopup from "../Components/popup/ErrorPopup";
import TextEditor from "../Components/RichTextEditor/TextEditor"; // ✅ Import your existing TextEditor
import countries from "world-countries";

const { Header, Content } = Layout;
const { Text } = Typography;

const AsanaUpload = () => {
  const [form] = Form.useForm();

  // ✅ Separate state for CKEditor fields (not controlled by Ant Form)
  const [howToDo, setHowToDo] = useState("");
  const [benefits, setBenefits] = useState("");
  const [precautions, setPrecautions] = useState("");

  // ✅ Validation error states for CKEditor fields
  const [howToDoError, setHowToDoError] = useState(false);
  const [benefitsError, setBenefitsError] = useState(false);
  const [precautionsError, setPrecautionsError] = useState(false);

  const [mainImage, setMainImage] = useState(null);
  const [mainImageList, setMainImageList] = useState([]);

  const [variationImages, setVariationImages] = useState([]);
  const [variationImageList, setVariationImageList] = useState([]);

  const [variationPoses, setVariationPoses] = useState([
    { name: "", sanskrit: "", country: "", english: "", poseType: "", mediaLink: "" },
  ]);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const user = JSON.parse(sessionStorage.getItem("user"));
  const role = user?.role || "user";

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const countryOptions = countries
    .map((c) => ({ label: c.name.common, value: c.name.common }))
    .sort((a, b) => a.label.localeCompare(b.label));

  // ✅ Strip HTML tags to check if editor is truly empty
  const isEditorEmpty = (html) => {
    const stripped = html.replace(/<[^>]*>/g, "").trim();
    return stripped.length === 0;
  };

  const handleSubmit = async (values) => {
    // ✅ Validate CKEditor fields manually before submission
    let hasError = false;

    if (isEditorEmpty(howToDo)) {
      setHowToDoError(true);
      hasError = true;
    }
    if (isEditorEmpty(benefits)) {
      setBenefitsError(true);
      hasError = true;
    }
    if (isEditorEmpty(precautions)) {
      setPrecautionsError(true);
      hasError = true;
    }

    if (hasError) return;

    setSubmitLoading(true);

    const formData = new FormData();

    const poseTypeArray = values.poseType
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    // Basic fields
    formData.append("name", values.name);
    formData.append("sanskrit", values.sanskrit);
    formData.append("tamil", values.tamil);
    formData.append("english", values.english);
    formData.append("breath", values.breath);
    formData.append("chakra", values.chakra);
    formData.append("level", values.level);
    poseTypeArray.forEach((item) => formData.append("poseType[]", item));

    // ✅ Send CKEditor HTML content as JSON strings
    formData.append("howToDo", JSON.stringify(howToDo));
    formData.append("benefits", JSON.stringify(benefits));
    formData.append("precautions", JSON.stringify(precautions));
    formData.append("variationPoses", JSON.stringify(variationPoses));

    if (mainImage) formData.append("mainImage", mainImage);
    variationImages.forEach((img) => img && formData.append("images", img));

    const token = sessionStorage.getItem("token");
    const apiUrl =
      role === "admin"
        ? `${BASE_URL}/asanadetails`
        : `${BASE_URL}/userasanas/submit`;

    try {
      await axios.post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      setSuccessPopup(true);

      // ✅ Reset everything including CKEditor fields
      form.resetFields();
      setHowToDo("");
      setBenefits("");
      setPrecautions("");
      setHowToDoError(false);
      setBenefitsError(false);
      setPrecautionsError(false);
      setMainImage(null);
      setMainImageList([]);
      setVariationImages([]);
      setVariationImageList([]);
      setVariationPoses([
        { name: "", sanskrit: "", country: "", english: "", poseType: "", mediaLink: "" },
      ]);
    } catch (err) {
      setErrorPopup(true);
    } finally {
      setSubmitLoading(false);
    }
  };

  const addVariationPose = () => {
    setVariationPoses([
      ...variationPoses,
      { name: "", sanskrit: "", country: "", english: "", poseType: "", mediaLink: "" },
    ]);
  };

  const updateVariationPose = (index, field, val) => {
    const updated = [...variationPoses];
    updated[index][field] = val;
    setVariationPoses(updated);
  };

  // ✅ Reusable error label style
  const errorStyle = {
    color: "#ff4d4f",
    fontSize: 12,
    marginTop: 4,
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role={role === "user" ? "user" : "admin"}
      />
      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 40 : 210,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >
        <Header className="MainHeader">
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <div style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>
              {role === "admin" ? "Add Asana" : "Upload User Asana"}
            </Text>
          </div>
        </Header>

        <Content style={{ padding: 20 }}>
          <Card style={{ maxWidth: 900, margin: "0 auto" }}>
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              autoComplete="off"
            >
              {/* ── BASIC INFORMATION ── */}
              <Card title="Basic Information" style={{ marginBottom: 20 }}>
                <Form.Item
                  label="Asana Name"
                  name="name"
                  rules={[{ required: true, message: "Please enter name" }]}
                >
                  <Input placeholder="Example: Trikonasana" />
                </Form.Item>

                <Form.Item
                  label="Sanskrit Name"
                  name="sanskrit"
                  rules={[{ required: true, message: "Enter Sanskrit" }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Tamil Name"
                  name="tamil"
                  rules={[{ required: true, message: "Enter Tamil" }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="English Name"
                  name="english"
                  rules={[{ required: true, message: "Enter English" }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Pose Type"
                  name="poseType"
                  rules={[{ required: true, message: "Enter pose types" }]}
                >
                  <Input placeholder="Example: twist, seated, forward bend" />
                </Form.Item>

                <Form.Item label="Level" name="level">
                  <Select>
                    <Select.Option value="all levels">All Levels</Select.Option>
                    <Select.Option value="beginner">Beginner</Select.Option>
                    <Select.Option value="intermediate">Intermediate</Select.Option>
                    <Select.Option value="advanced">Advanced</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Breath"
                  name="breath"
                  rules={[{ required: true, message: "Enter breath info" }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Chakra"
                  name="chakra"
                  rules={[{ required: true, message: "Enter chakra" }]}
                >
                  <Input />
                </Form.Item>
              </Card>

              {/* ── INSTRUCTIONS with CKEditor ── */}
              <Card title="Instructions" style={{ marginBottom: 20 }}>

                {/* HOW TO DO */}
                <Form.Item label="How To Do" required>
                  <TextEditor
                    key={`howToDo-${successPopup}`} // ✅ Force re-mount on reset
                    initialData={howToDo}
                    onChange={(data) => {
                      setHowToDo(data);
                      if (!isEditorEmpty(data)) setHowToDoError(false);
                    }}
                    uploadUrl={`${BASE_URL}/api/upload`}
                  />
                  {howToDoError && (
                    <p style={errorStyle}>Please enter how to do steps</p>
                  )}
                </Form.Item>

                {/* BENEFITS */}
                <Form.Item label="Benefits" required style={{ marginTop: 16 }}>
                  <TextEditor
                    key={`benefits-${successPopup}`}
                    initialData={benefits}
                    onChange={(data) => {
                      setBenefits(data);
                      if (!isEditorEmpty(data)) setBenefitsError(false);
                    }}
                    uploadUrl={`${BASE_URL}/api/upload`}
                  />
                  {benefitsError && (
                    <p style={errorStyle}>Please enter benefits</p>
                  )}
                </Form.Item>

                {/* PRECAUTIONS */}
                <Form.Item label="Precautions" required style={{ marginTop: 16 }}>
                  <TextEditor
                    key={`precautions-${successPopup}`}
                    initialData={precautions}
                    onChange={(data) => {
                      setPrecautions(data);
                      if (!isEditorEmpty(data)) setPrecautionsError(false);
                    }}
                    uploadUrl={`${BASE_URL}/api/upload`}
                  />
                  {precautionsError && (
                    <p style={errorStyle}>Please enter precautions</p>
                  )}
                </Form.Item>
              </Card>

              {/* ── MAIN IMAGE ── */}
              <Card title="Main Image" style={{ marginBottom: 20 }}>
                <Upload
                  listType="picture"
                  fileList={mainImageList}
                  beforeUpload={(file) => {
  const previewFile = {
    uid: file.uid,
    name: file.name,
    status: "done",
    url: URL.createObjectURL(file),
    originFileObj: file,
  };
  setMainImage(file);
  setMainImageList([previewFile]);
  return false;
}}
                  onRemove={() => {
                    setMainImage(null);
                    setMainImageList([]);
                  }}
                  maxCount={1}
                >
                  <Button icon={<UploadOutlined />}>Upload Image</Button>
                </Upload>
              </Card>

              {/* ── VARIATION POSES ── */}
              <Card
                title="Variation Poses"
                extra={
                  <Button icon={<PlusOutlined />} onClick={addVariationPose}>
                    Add Variation
                  </Button>
                }
              >
                {variationPoses.map((pose, idx) => (
                  <Card
                    key={idx}
                    type="inner"
                    title={`Variation ${idx + 1}`}
                    style={{ marginBottom: 15, position: "relative" }}
                  >
                    <Button
                      danger
                      size="small"
                      style={{ position: "absolute", top: 10, right: 10, fontSize: 12 }}
                      onClick={() => {
                        setVariationPoses(variationPoses.filter((_, i) => i !== idx));
                        setVariationImages(variationImages.filter((_, i) => i !== idx));
                        setVariationImageList(variationImageList.filter((_, i) => i !== idx));
                      }}
                    >
                      Delete
                    </Button>

                    <Space direction="vertical" style={{ width: "100%" }}>
                      <Input
                        placeholder="Name"
                        value={pose.name}
                        onChange={(e) => updateVariationPose(idx, "name", e.target.value)}
                      />
                      <Input
                        placeholder="Sanskrit"
                        value={pose.sanskrit}
                        onChange={(e) => updateVariationPose(idx, "sanskrit", e.target.value)}
                      />
                      <Select
                        showSearch
                        placeholder="Select country"
                        value={pose.country || undefined}
                        options={countryOptions}
                        optionFilterProp="label"
                        style={{ width: "100%" }}
                        onChange={(value) => updateVariationPose(idx, "country", value)}
                      />
                      <Input
                        placeholder="English"
                        value={pose.english}
                        onChange={(e) => updateVariationPose(idx, "english", e.target.value)}
                      />
                      <Input
                        placeholder="Pose Type"
                        value={pose.poseType}
                        onChange={(e) => updateVariationPose(idx, "poseType", e.target.value)}
                      />
                      <Input
                        placeholder="Media Link"
                        value={pose.mediaLink}
                        onChange={(e) => updateVariationPose(idx, "mediaLink", e.target.value)}
                      />
                      <Upload
                        listType="picture"
                        fileList={variationImageList.filter((_, i) => i === idx)}
                        beforeUpload={(file) => {
                          const updatedImages = [...variationImages];
                          updatedImages[idx] = file;
                          setVariationImages(updatedImages);

                          const updatedList = [...variationImageList];
                          updatedList[idx] = file;
                          setVariationImageList(updatedList);
                          return false;
                        }}
                        onRemove={() => {
                          setVariationImages(variationImages.filter((_, i) => i !== idx));
                          setVariationImageList(variationImageList.filter((_, i) => i !== idx));
                        }}
                        maxCount={1}
                      >
                        <Button icon={<UploadOutlined />}>Upload Image</Button>
                      </Upload>
                    </Space>
                  </Card>
                ))}
              </Card>

              <Divider />

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={submitLoading}
                  disabled={submitLoading}
                >
                  {submitLoading ? "Uploading..." : "Upload Asana"}
                </Button>
              </Form.Item>

              <SuccessPopup
                open={successPopup}
                onClose={() => setSuccessPopup(false)}
                message="Asana uploaded successfully!"
                navigate={role === "admin" ? "/all-asana" : "/my-variations"}
              />
              <ErrorPopup
                open={errorPopup}
                onClose={() => setErrorPopup(false)}
                message="Upload failed. Try again."
              />
            </Form>
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AsanaUpload;